import React from 'react';
import PropTypes from 'prop-types';
import SVGWrap from './SVGWrap';

const Truck = ({ noFill, outlineColor, s }) => (
  <SVGWrap style={s}>
    <path
      fill={outlineColor}
      d="M427.5,270.5h-67.3c-8,0-15.2-6.5-15.2-15.2v-63.7c0-8,6.5-15.2,15.2-15.2h29.7c5.8,0,11.6,2.9,15.2,8l40.5,52.1
	c4.3,6.5,5.1,15.2,0.7,22.4C442.7,266.8,435.4,270.5,427.5,270.5z M360.2,188.7c-2.2,0-3.6,1.4-3.6,3.6V256c0,2.2,1.4,3.6,3.6,3.6
	h67.3c3.6,0,7.2-2.2,9.4-5.1c1.4-3.6,1.4-7.2,0-10.1l-41.2-52.8c-1.4-2.2-3.6-2.9-5.8-2.9C389.9,188.7,360.2,188.7,360.2,188.7z"
    />
    <path
      fill={outlineColor}
      d="M497.6,260.3l-5.8-5.8L419.5,159c-7.2-9.4-18.1-15.2-29.7-15.2H99.7l26.8-26.8c2.2-2.2,2.2-5.8,0-8c-2.2-2.2-5.8-2.2-8,0
	L81.7,146c-2.2,2.2-2.2,5.8,0,8l37.6,37.6c1.4,1.4,2.9,1.4,4.3,1.4c1.4,0,2.9-0.7,4.3-1.4c2.2-2.2,2.2-5.8,0-8l-28.2-28.2h290.8
	c8,0,15.9,3.6,21,10.1l72.3,95.5l5.8,6.5c5.8,6.5,9.4,15.2,9.4,23.9v43.4c0,12.3-10.1,22.4-22.4,22.4h-38.3
	c-2.9-19.5-19.5-34.7-39.8-34.7c-20.3,0-36.9,15.2-39.8,34.7H197.4c-2.9-19.5-19.5-34.7-39.8-34.7s-36.9,15.2-39.8,34.7h-55
	c-2.9,0-5.8,2.9-5.8,5.8c0,2.9,2.9,5.8,5.8,5.8h55c2.9,19.5,19.5,34.7,39.8,34.7s36.9-15.2,39.8-34.7H358
	c2.9,19.5,19.5,34.7,39.8,34.7s36.9-15.2,39.8-34.7h38.3c18.8,0,34-15.2,34-34v-43.4C509.9,280.6,505.6,269,497.6,260.3z M157.6,392
	c-15.9,0-28.9-13-28.9-28.9c0-15.9,13-28.9,28.9-28.9s28.9,13,28.9,28.9C186.6,379,173.5,392,157.6,392z M397.8,392
	c-15.2,0-28.2-12.3-28.9-27.5v-1.4v-1.4c0.7-15.2,13-27.5,28.9-27.5s28.9,13,28.9,28.9C426.7,379,413.7,392,397.8,392z"
    />
    {!noFill && (
      <path
        className="st0"
        style={{ opacity: 0.1, enableBackground: 'new' }}
        fill={outlineColor}
        d="M489.7,268.3l-5.8-6.5l-72.3-95.5c-5.1-6.5-13-10.1-21-10.1H124.3c10.9,6.5,18.8,18.8,18.8,33.3
	c0,21.7-17.4,39.1-39.1,39.1h-21c-6.5,0.7-11.6,6.5-11.6,13.7c0,8,6.5,13.7,13.7,13.7h85.4c2.9,0,5.1,2.2,5.1,5.1s-2.2,5.1-5.1,5.1
	h58.6c8,0,14.5,6.5,14.5,14.5c0,8-6.5,14.5-14.5,14.5h-1.4c2.9,0,5.1,2.2,5.1,5.1s-2.2,5.1-5.1,5.1h-92.6c12.3,0,22.4,8,26,19.5
	c18.8,1.4,34,15.9,36.9,34h160.6c2.9-19.5,19.5-34.7,39.8-34.7c20.3,0,36.9,15.2,39.8,34.7h38.3c12.3,0,22.4-10.1,22.4-22.4v-43.4
	C499.1,283.5,495.5,274.8,489.7,268.3z M446.3,259.6c-3.6,7.2-10.9,11.6-18.8,11.6h-67.3c-8,0-15.2-6.5-15.2-15.2v-63.7
	c0-8,6.5-15.2,15.2-15.2h29.7c5.8,0,11.6,2.9,15.2,8l40.5,52.1C449.9,244.4,449.9,252.4,446.3,259.6z"
      />
    )}
    <path
      fill={outlineColor}
      d="M227.1,303.7h-123c-2.9,0-5.1-2.2-5.1-5.1s2.2-5.1,5.1-5.1h123c2.9,0,5.1,2.2,5.1,5.1S229.2,303.7,227.1,303.7z
	 M169.9,265.4H6.4c-2.9,0-5.1-2.2-5.1-5.1s2.2-5.1,5.1-5.1h163.5c2.9,0,5.1,2.2,5.1,5.1S172.8,265.4,169.9,265.4z"
    />
  </SVGWrap>
);

Truck.defaultProps = {
  noFill: false,
  outlineColor: '#000000',
  s: {},
};

Truck.propTypes = {
  noFill: PropTypes.bool,
  s: PropTypes.object,
  outlineColor: PropTypes.string,
};

export default Truck;
